import { publishEditedQr } from 'features/generator/utils/publishEditedQr'
import { refreshQrList } from 'features/library/client'
import { useTranslations } from 'next-intl'
import { useBus } from 'react-bus'

import { showNotification } from '@/components/Notification'
import { BUILDER_EDIT_MODES } from '@/constants'
import { useRouter } from '@/i18n-routing'
import { getStore } from '@/store'
import { getSearchParams } from '@/utils'

import { qrNameAtom } from '../../contentFormSections'
import { RESET_NEXT_BUTTON_LOADING_EVENT } from '../../GeneratorLayout/GeneratorFooter/NextButton'
import { GENERATOR_SEARCH_PARAM, QR_TYPE } from '../../generatorTypes'
import { qrDesignAtom } from '../../pages/QrDesignFormPage/qrDesignState'
import { seedDraftPasswordFromTarget } from '../../pages/QrDesignFormPage/qrPasswordDraft'
import { qrCodesApi } from '../../services/shared'
import { buildEditModeContentFormPageUrl } from '../../utils/BuildEditModeContentFormPageUrl'
import { setGeneratorSearchParam } from '../../utils/generatorSearchParam'
import { QR_TYPE_TO_CONTENT_ATOM } from '../../utils/qrTypeToContentAtom'

export const useSaveContentForm = (qrType: QR_TYPE) => {
	const t = useTranslations()
	const router = useRouter()
	const bus = useBus()

	return async () => {
		try {
			await publishEditedQr(qrType)
			void refreshQrList()
			showNotification(t('generator__footer__edit_mode__save_toast_message'), {
				type: 'success',
				context: 'generator',
			})
			const {
				data: { id: tempQrId },
			} = await qrCodesApi.postQr({
				name: getStore().get(qrNameAtom) || '',
				content: getStore().get(QR_TYPE_TO_CONTENT_ATOM[qrType]),
				qrDesign: getStore().get(qrDesignAtom),
			})
			await seedDraftPasswordFromTarget(tempQrId, qrType)
			setGeneratorSearchParam(GENERATOR_SEARCH_PARAM.Id, tempQrId)
			const targetId = getSearchParams().get(GENERATOR_SEARCH_PARAM.Target)
			if (!targetId) {
				throw new Error('Missing target QR ID')
			}
			router.replace(
				buildEditModeContentFormPageUrl({
					qrType,
					targetId,
					tempQrId: tempQrId,
					isChangeTypeMode:
						getSearchParams().get(GENERATOR_SEARCH_PARAM.Edit) ===
						BUILDER_EDIT_MODES.TYPE,
				}),
			)
			router.refresh()
		} catch (error) {
			showNotification(t('public__backend_save_error'), {
				type: 'error',
				context: 'generator',
			})
			console.error('Failed saving edited QR', error)
		} finally {
			bus.emit(RESET_NEXT_BUTTON_LOADING_EVENT)
		}
	}
}
